import * as React from "react"
import Seo from "@shared/head/Seo"

import Lottie from "@shared/uiNew/LazyLottie"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "@app/Layout"
import CasesSection from "@/features/chat/sections/CasesSection"
import CardsSectionChat from "@/features/chat/sections/CardsSectionChat"
import Support from "@/features/chat/sections/Support"
import Dialog from "@/features/chat/sections/Dialog"
import Marketing from "@/features/chat/sections/Marketing"
import Sales from "@/features/chat/sections/Sales"
import Start from "@/features/chat/sections/Start"

import Canonical from "@shared/head/Canonical"
import Breadcrumbs from "@shared/head/Breadcrumbs"
import Button from "@shared/uiNew/Button/button"
import { HeroColumns } from "@shared/uiNew/HeroSections/HeroColumns"

import markerAnimationHero from "@shared/animations/animation_6.json"

import * as styles from "@/features/chat/styles.module.scss"
import NewFAQ from "@widgets/NewFAQ"
import ResultsSupport from "@/features/chat/sections/ResultsSupport"
import lineAnimation from "@shared/animations/underline.json"
import LeadFormSection from "@widgets/LeadFormSection"
import step1 from "@/features/chat/sections/HowItWorks/assets/step1.webp"
import step2 from "@/features/chat/sections/HowItWorks/assets/step2.webp"
import step3 from "@/features/chat/sections/HowItWorks/assets/step3.webp"
import HowItWorksSection from "@/features/chat/sections/HowItWorks"

// SEO Meta
export const Head = () => (
  <Seo title="Онлайн-чат для сайта" description="Подключите чат для вашего сайта. Повысьте конверсию и продажи на сайте. Установка за 10 минут. Попробуйте сейчас - 7 дней бесплатно" path="/chat/" image="https://www.carrotquest.io/cover/ru/chat.png">
  <Breadcrumbs
        list={[
          { name: "Carrot quest", url: "https://www.carrotquest.io/" },
          {
            name: "Чат на сайте от Carrot quest",
            url: "https://www.carrotquest.io/chat/",
          },
        ]}
      />
  </Seo>
)

const CarrotChat = ({ location }) => {
  const inViewOptions = { triggerOnce: true, threshold: 0.2 }

  return (
    <Layout location={location} className={`${styles.chat} new-design`}>
      <HeroColumns
        title={title}
        subTitle={subTitle}
        button={<Button text="Оставить заявку на демо" icon="arrow" variant="primary" />}
        secondButton={<Button text="Попробовать бесплатно" variant="outline" />}
        img={img}
        className={styles.hero}
      />

      <CasesSection />

      <CardsSectionChat />

      <HowItWorksSection />

      <Support />

      <Dialog />

      <Marketing />

      <Sales />

      <section className={styles.security}>
        <div className={styles.securityWrapper}>
          <div>
            <svg width="285" height="262" viewBox="0 0 285 262" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M164.434 98.4824L164.479 98.4834L164.922 98.4932L164.965 98.4941L165.008 98.4961C166.278 98.5519 167.527 98.7788 168.748 99.1611L169.27 99.334L169.328 99.3555L199.787 110.604L199.813 110.613L199.84 110.624C202.325 111.582 204.42 113.116 206.06 115.186L206.382 115.606V115.607C208.12 117.966 209.003 120.674 209 123.604V147.246L208.999 147.265L208.989 148.357V148.375L208.988 148.393C208.769 160.451 205.133 171.724 198.172 182.138L198.152 182.167L197.511 183.108L197.487 183.142C190.297 193.465 180.703 200.622 168.808 204.523L168.776 204.534L168.744 204.544L168.389 204.653V205.3L164.364 205.224H160.389V204.653L160.033 204.544L160 204.534L159.968 204.523C148.073 200.619 138.48 193.46 131.289 183.137L131.266 183.104L130.625 182.162L130.614 182.147L130.604 182.133C123.417 171.38 119.777 159.717 119.777 147.228V123.604C119.778 120.863 120.552 118.307 122.091 116.046L122.109 116.019L122.129 115.991L122.352 115.675L122.4 115.606C124.083 113.324 126.287 111.647 128.936 110.625L128.99 110.604L159.448 99.3555L159.507 99.334C161.092 98.7765 162.725 98.4824 164.389 98.4824H164.434ZM164.389 109.888C164.101 109.888 163.758 109.935 163.33 110.085L133.101 121.25L132.805 121.376C132.401 121.569 132.071 121.821 131.769 122.187L131.637 122.355C131.352 122.742 131.233 123.082 131.233 123.605V147.228C131.233 157.369 134.149 166.849 140.142 175.814C146.004 184.584 153.749 190.473 163.556 193.692C163.717 193.745 163.849 193.776 163.954 193.793L164.096 193.809C164.167 193.814 164.264 193.818 164.389 193.818C164.637 193.818 164.775 193.801 164.822 193.793C164.927 193.776 165.06 193.745 165.222 193.692L166.147 193.378C175.51 190.102 182.955 184.318 188.636 175.819C194.628 166.854 197.543 157.373 197.543 147.228V123.648L197.531 123.334C197.503 123.026 197.422 122.77 197.236 122.485L197.146 122.355C196.762 121.835 196.332 121.504 195.719 121.265L165.439 110.083C165.013 109.934 164.673 109.888 164.389 109.888Z"
                fill="#A7A7FF"
                stroke="#A7A7FF"
                strokeWidth="8"
              />
              <path
                d="M174.324 73.001C183.956 73.001 191.765 80.8095 191.765 90.4414V144.908C191.765 154.54 183.956 162.349 174.324 162.349H89.4404C79.8085 162.349 72 154.54 72 144.908V90.4414C72 80.8095 79.8085 73.001 89.4404 73.001H174.324Z"
                fill="#A7A7FF"
                stroke="#A7A7FF"
                strokeWidth="8"
              />
              <path
                d="M174.372 73.001L174.719 73.0059H174.746L174.772 73.0068C184.198 73.2456 191.765 80.9595 191.765 90.4414V144.956L191.761 145.303L191.76 145.33V145.356C191.556 153.414 185.889 160.111 178.324 161.887V162.349H174.372L170.324 162.396V162.349H93.4404V162.396L89.3926 162.349H85.4404V161.887C77.8757 160.111 72.2099 153.414 72.0059 145.356L72.0049 145.33V145.304L72 144.956V90.4414L72.0059 89.998C72.2372 80.72 79.7134 73.2418 88.9922 73.0068L89.0186 73.0059H89.0459L89.3926 73.001H174.372ZM85.2451 100.878L81.418 145.038C81.4849 149.273 84.8296 152.711 89.0273 152.924L89.4404 152.934H174.324C178.656 152.934 182.184 149.502 182.342 145.208L174.562 100.14L85.2451 100.878ZM89.4404 82.416C86.6138 82.416 84.1289 83.8784 82.6992 86.0869H181.065C179.636 83.8784 177.151 82.416 174.324 82.416H89.4404Z"
                fill="#A7A7FF"
                stroke="#A7A7FF"
                strokeWidth="8"
              />
              <path
                d="M85 78.001H178.765C183.183 78.001 186.765 81.5827 186.765 86.001V149.349C186.765 153.767 183.183 157.349 178.765 157.349H85C80.5817 157.349 77 153.767 77 149.349V86.001C77 81.5827 80.5817 78.001 85 78.001Z"
                fill="#A7A7FF"
                stroke="black"
                strokeWidth="2"
              />
              <path
                d="M164.389 103.482C165.448 103.482 166.516 103.668 167.595 104.046H167.596L198.046 115.291C199.813 115.973 201.244 117.064 202.357 118.574C203.458 120.067 204.003 121.733 204 123.604V147.229C204 158.687 200.679 169.391 194.016 179.359C187.37 189.302 178.456 196.098 167.25 199.773H167.249C166.789 199.925 166.331 200.037 165.876 200.111C165.429 200.185 164.934 200.224 164.389 200.224C163.843 200.224 163.347 200.185 162.9 200.111C162.446 200.037 161.988 199.925 161.527 199.773C150.321 196.094 141.408 189.297 134.762 179.354C128.098 169.386 124.777 158.684 124.777 147.229V123.605C124.777 121.734 125.324 120.068 126.425 118.574C127.54 117.062 128.97 115.971 130.736 115.289L130.735 115.288L161.182 104.046C162.261 103.668 163.329 103.482 164.389 103.482Z"
                fill="#A7A7FF"
                stroke="black"
                strokeWidth="2"
              />
              <path d="M236.528 198.428L255.855 196.76" stroke="black" strokeWidth="2" strokeLinecap="round" />
              <path d="M240.707 209.897L245.681 214.02" stroke="black" strokeWidth="2" strokeLinecap="round" />
              <path
                d="M224.531 219.6C229.498 228.36 234.464 237.12 238.545 243.832C242.625 250.543 245.669 254.941 248.77 260.604"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path d="M44.75 64.09L25.3527 63.8136" stroke="black" strokeWidth="2" strokeLinecap="round" />
              <path d="M41.7395 52.2605L37.2031 47.6601" stroke="black" strokeWidth="2" strokeLinecap="round" />
              <path
                d="M58.8066 44.2266C54.7425 35.013 50.6784 25.7995 47.2907 18.713C43.9029 11.6265 41.3147 6.9462 38.7965 1.00057"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </div>

          <div className={styles.securityContent}>
            <h2 className="h1">
              Безопасность <br />
              и соответствие ФЗ
            </h2>
            <p>
              Ваши данные надежно защищены. Мы состоим в реестре отечественного ПО, храним данные на территории РФ (соответствие 152-ФЗ) и поддерживаем гибкое
              управление ролями (RBAC), чтобы доступ к базе был только у авторизованных сотрудников
            </p>
          </div>
        </div>
      </section>

      <Start />

      <ResultsSupport />

      <NewFAQ faq={faq} />

      <LeadFormSection
        renderTitle={renderTitle}
        formTitle={<h2>Запишитесь на демо</h2>}
        formDescription={<>мы покажем, как онлайн-чат и инструменты автоматизации Carrot quest помогут именно вашему бизнесу работать эффективнее.</>}
      />
    </Layout>
  )
}

const img = (
  <StaticImage
    src="../../features/chat/assets/hero.png"
    alt="Иллюстрация для главного экрана, декоративная"
    style={{ marginBottom: "-2px" }}
    width={700}
    loading="eager"
    placeholder="blurred"
  />
)

const title = (
  <h1>
    Современный{" "}
    <span className={styles.heroHighlight}>
      онлайн-чат
      <Lottie animationData={markerAnimationHero} loop={false} autoplay />
    </span>{" "}
    на сайте для маркетинга, продаж и поддержки
  </h1>
)

const subTitle = (
  <>Направит потенциальных клиентов в продажи, а действующих — в поддержку. Обеспечивает мгновенную реакцию на обращения с помощью чат-ботов и AI.</>
)

const faq = [
  {
    "@type": "Question",
    name: "Как онлайн-чат для сайта поможет бизнесу?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `Чат поможет:
         <ol>
            <li>Быть на связи с клиентами, чтобы помочь в выборе товаров или проконсультировать по их использованию;</li>
            <li>Отвечать на сообщения с сайта, из соцсетей и мессенджеров в едином окне;</li>
            <li>Снять нагрузку с кол&#8209;центра и автоматизировать обработку обращений;</li>
            <li>Контролировать качество и скорость ответов клиентам;</li>
            <li>Вовлекать пользователей в диалог и помогать с выбором, чтобы приблизить их к покупке;</li>
            <li>Автоматически квалифицировать лидов;</li>
            <li>Передавать целевых лидов команде продаж.</li>
        </ol>`,
    },
  },
  {
    "@type": "Question",
    name: "Каким командам будет полезен чат?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `<ul>
            <li><a target="_blank" href="https://www.carrotquest.io/support/">поддержке</a> — чтобы оперативно отвечать на вопросы и решать проблемы клиентов;</li>
            <li><a target="_blank" href="https://www.carrotquest.io/sales/">продажам</a> — чтобы консультировать и продавать тем, кто интересуется товаром;</li>
            <li><a target="_blank" href="https://www.carrotquest.io/for-marketing-teams/">маркетингу</a> — чтобы собирать лидов.</li>
        </ul>`,
    },
  },
  {
    "@type": "Question",
    name: "Какие задачи сможет решить команда маркетинга с помощью чата?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `Команда маркетинга может использовать онлайн&#8209;чат для сайта, чтобы:
        <ol>
            <li>Вовлечь больше посетителей сайта в диалог с компанией за счет персонализированных триггерных сообщений;</li>
            <li>Квалифицировать пользователей: кто уже является клиентом, а кому еще нужно продать;</li>
            <li>Собирать контакты пользователей, которые обращаются в чат;</li>
            <li>Рассказывать посетителям об акциях и специальных предложениях.</li>
        </ol>`,
    },
  },
  {
    "@type": "Question",
    name: "Как установить онлайн-чат для сайта?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `Чтобы установить чат от Carrot quest, нужно вставить скрипт нашего сервиса в код вашего сайта так же, как скрипты аналитики.
        <br/>
        <br/>
        Благодаря <a href="https://www.carrotquest.io/chat/apps/live-chat-for-wordpress/" target="_blank">интеграции с WordPress</a> вы можете быстро и легко установить онлайн-чат на сайт, собранный на этой платформе.
        <br/>
        <br/>
        Также вы можете установить приложения для операторов, чтобы удобно и оперативно общаться с пользователями:
        <ul>
            <li><a href="https://www.carrotquest.io/chat/apps/live-chat-for-windows/"  target="_blank">десктопное для Windows</a>,</li>
            <li><a href="https://www.carrotquest.io/chat/apps/live-chat-web-app/"  target="_blank">web-приложение</a>,</li>
            <li><a href="https://www.carrotquest.io/chat/apps/live-chat-for-android/"  target="_blank">для Android</a>,</li>
            <li><a href="https://www.carrotquest.io/chat/apps/live-chat-for-ios/"  target="_blank">для iOS</a>.</li>
        </ul>`,
    },
  },
  {
    "@type": "Question",
    name: "С какими каналами можно интегрировать онлайн-чат для сайта?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `Вы можете интегрировать чат со всеми популярными соцсетями и мессенджерами:
        <ol>
            <li><a href="https://www.carrotquest.io/integration/vk/" target="_blank">ВКонтакте</a></li>
            <li><a href="https://www.carrotquest.io/integration/telegram/" target="_blank">Telegram</a></li>
            <li><a href="https://www.carrotquest.io/integration/viber/" target="_blank">Viber</a></li>
<!--            <li><a href="https://www.carrotquest.io/integration/facebook/" target="_blank">Facebook</a></li>-->
<!--            <li><a href="https://www.carrotquest.io/integration/instagram/" target="_blank">Instagram</a> — чтобы отвечать на сообщения, комментарии, реакции и упоминания;</li>-->
            <li><a href="https://www.carrotquest.io/integration/whatsapp/" target="_blank">WhatsApp</a> — чтобы быстрее отвечать на вопросы клиентов и не беспокойтесь за блокировку номера;</li>
            <li><a href="https://www.carrotquest.io/integration/slack/" target="_blank">Slack</a> — чтобы получать уведомления о важных действиях пользователей;</li>
            <li><a target="_blank" href="https://help.carrotquest.io/article/1274?_gl=1*1g67lrd*_ga*MTk5NTY4OTYzNS4xNjY3MjEyNjE5*_ga_QWX1N5X5XL*MTY3NTE0Mzc1OS4xMTcuMS4xNjc1MTQzNzY0LjAuMC4w&_ga=2.59810157.1387276907.1675054289-1995689635.1667212619">Zoom</a> — чтобы создавать видео-встречи не покидая чата.</li>
        </ol>
      `,
    },
  },
  {
    "@type": "Question",
    name: "Можно ли интегрировать чат на сайте с CRM?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `Да, у Carrot quest есть интеграции с CRM-системами, например,
            <a href="https://www.carrotquest.io/integration/amocrm/" target="_blank">amoCRM</a>,
            <a href="https://www.carrotquest.io/integration/bitrix24/" target="_blank">Bitrix24</a>,
            <a href="https://www.carrotquest.io/integration/retailcrm/" target="_blank">RetailCRM</a>.
            <br/>
            <br/>
            <a href="https://www.carrotquest.io/integration/" target="_blank">Посмотрите все интеграции</a>`,
    },
  },
  {
    "@type": "Question",
    name: "Можно ли интегрировать чат на сайте с аналитикой?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Да, у Carrot quest есть интеграции с системами аналитики, например,
      <a href="https://help.carrotquest.io/article/147?_gl=1*1g67lrd*_ga*MTk5NTY4OTYzNS4xNjY3MjEyNjE5*_ga_QWX1N5X5XL*MTY3NTE0Mzc1OS4xMTcuMS4xNjc1MTQzNzY0LjAuMC4w&_ga=2.59810157.1387276907.1675054289-1995689635.1667212619" target="_blank">
      Google Analytics</a>,
      <a href="https://help.carrotquest.io/article/144?_gl=1*1nzio1f*_ga*MTk5NTY4OTYzNS4xNjY3MjEyNjE5*_ga_QWX1N5X5XL*MTY3NTE0Mzc1OS4xMTcuMS4xNjc1MTQzNzY0LjAuMC4w&_ga=2.33140094.1387276907.1675054289-1995689635.1667212619" target="_blank">
      Яндекс.Метрика</a>,
      <a href="https://help.carrotquest.io/article/145?_gl=1*1nzio1f*_ga*MTk5NTY4OTYzNS4xNjY3MjEyNjE5*_ga_QWX1N5X5XL*MTY3NTE0Mzc1OS4xMTcuMS4xNjc1MTQzNzY0LjAuMC4w&_ga=2.33140094.1387276907.1675054289-1995689635.1667212619" target="_blank">
      Roistat</a>.
      <br />
      <br />
      <a href="https://www.carrotquest.io/integration/" target="_blank">Посмотрите все интеграции</a>`,
    },
  },
  {
    "@type": "Question",
    name: "Как ускорить обработку обращений с помощью онлайн-чата для сайта от Carrot quest?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Чтобы быстрее закрывать диалоги:
      <ol>
        <li>Используйте информацию из карточки клиента, чтобы не задавать лишние уточняющие вопросы.</li>
        <li>Подключите <a href="https://www.carrotquest.io/chatbot/" target="_blank">чат-бота</a>, чтобы отвечать на популярные вопросы автоматически.</li>
        <li>Используйте сохраненные ответы.</li>
        <li>Используйте горячие клавиши.</li>
        <li>Назначайте диалог на другого менеджера, если не можете ответить на вопрос.</li>
      </ol>
      Также установите приложения, чтобы быстро реагировать на обращения:
        <ul>
          <li><a href="https://www.carrotquest.io/chat/apps/live-chat-for-windows/" target="_blank">десктопное для Windows</a>,</li>
          <li><a href="https://www.carrotquest.io/chat/apps/live-chat-web-app/" target="_blank">web-приложение</a>,</li>
          <li><a href="https://www.carrotquest.io/chat/apps/live-chat-for-android/" target="_blank">для Android</a>,</li>
          <li><a href="https://www.carrotquest.io/chat/apps/live-chat-for-ios/" target="_blank">для iOS</a>.</li>
        </ul>
      `,
    },
  },
]

const renderTitle = (inView: boolean) => (
  <h2 className="h1">
    Готовы быть на{" "}
    <span className={styles.highlightForm}>
      связи с каждым
      {inView && <Lottie animationData={lineAnimation} loop={false} autoplay />}
    </span>{" "}
    клиентом и растить продажи?
  </h2>
)

const steps = [
  {
    id: 1,
    label: "Маркетинг",
    title: "Создайте поток лидов",
    image: step1,
    content: (
      <ul>
        <li>Сбор лидов</li>
        <li>Квалификация</li>
      </ul>
    ),
  },
  {
    id: 1,
    label: "Маркетинг",
    title: "Создайте поток лидов",
    image: step2,
    content: (
      <ul>
        <li>Сбор лидов</li>
        <li>Квалификация</li>
      </ul>
    ),
  },
  {
    id: 1,
    label: "Маркетинг",
    title: "Создайте поток лидов",
    image: step3,
    content: (
      <ul>
        <li>Сбор лидов</li>
        <li>Квалификация</li>
      </ul>
    ),
  },
]

export default CarrotChat
